export function getTweets(userName, count = 1) {
    $.ajax({
        url: "/latest/tweets",
        method: "POST",
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        data: { twitterName: userName },
        success: function (data) {
            if (!(data.view === "")) {
                if (count == 1) {
                    $("#twitter").append(
                        '<div class="twitter-whole" id="tweet' +
                            count +
                            '">' +
                            '<div class="link-underlined mb-2"><strong>Twitter:</strong> <span class="twitter-screenname a">@' +
                            userName +
                            "</span></div>" +
                            '<div class="twitter-feed-body  owl-carousel owl-theme" id="tweetfeed' +
                            count +
                            '">' +
                            "</div></div>"
                    );
                    $("#tweetfeed1").html(data.view);
                    $(".owl-carousel").owlCarousel({
                        items: 2,
                        dots: false,
                        nav: true,
                        mouseDrag: true,
                        navText: [
                            "<i class='fa fa-caret-left'></i>",
                            "<i class='fa fa-caret-right'></i>",
                        ],
                        responsiveClass: true,
                        responsive: {
                            0: {
                                margin: 0,
                                items: 2,
                                nav: true,
                            },
                            480: {
                                margin: 0,
                                items: 2,
                                nav: true,
                            },
                            1000: {
                                items: 2,
                                nav: true,
                            },
                        },
                    });
                } else {
                    $("#twitter").append(
                        '<div class="twitter-whole" id="tweet' +
                            count +
                            '">' +
                            '<div class="link-underlined mb-2"><strong>Twitter:</strong> <span class="twitter-screenname a">' +
                            userName +
                            "</span></div>" +
                            '<div class="twitter-feed-body  owl-carousel owl-theme" id="tweetfeed' +
                            count +
                            '">' +
                            "</div></div>"
                    );
                    $("#tweetfeed" + count).append(data.view);
                }
            } else {
                $("#twitter").append(
                    '<div class="twitter-whole" id="tweet' +
                        count +
                        '">' +
                        '<div class="link-underlined mb-2"><strong>Twitter:</strong> <span class="twitter-screenname a">' +
                        userName +
                        "</span></div>" +
                        '<div class="twitter-feed-body  owl-carousel owl-theme" id="tweetfeed' +
                        count +
                        '">' +
                        "</div></div>"
                );
            }
        },
        error: function (req, status, err) {
            if (status === "error") {
                $(".twitter-whole").css("display", "none");
                $(".owl-carousel").css("display", "none");
            }
        },
    });
}
